(() => {
  'use strict';
  const root = document.getElementById('CCMobileMenu');
  if (!root || root.dataset.ccReady) return;
  root.dataset.ccReady = '1';
  // Hoist above header stacking contexts to keep the sheet unobstructed.
  if (root.parentElement !== document.body) document.body.appendChild(root);
  const track = root.querySelector('[data-cc-mm-track]');
  const tabs = [...root.querySelectorAll('[data-cc-mm-tab]')];
  const panels = [...root.querySelectorAll('[data-cc-mm-panel]')];
  const scrollArea = root.querySelector('[data-cc-mm-scroll]');
  let previousFocus = null;
  let closeTimer = 0;
  let expandedTab = null;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function selectTab(tab) {
    const wasOpen = expandedTab === tab;
    expandedTab = wasOpen ? null : tab;
    tabs.forEach(button => button.setAttribute('aria-expanded', String(button === expandedTab)));
    panels.forEach(panel => { panel.hidden = !expandedTab || panel.dataset.ccMmPanel !== expandedTab.dataset.ccMmTab; });
    scrollArea.scrollTop = 0;
  }
  function open() {
    if (window.innerWidth > 768 || root.classList.contains('is-active')) return;
    clearTimeout(closeTimer);
    previousFocus = document.activeElement;
    const mobileHeader = document.querySelector('.cc-mobile-header-shell #SiteHeader');
    const bottom = mobileHeader?.getBoundingClientRect().bottom || 62;
    root.style.setProperty('--cc-mm-top', `${Math.max(0, Math.min(120, Math.round(bottom)))}px`);
    root.inert = false;
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-active');
    document.body.classList.add('cc-mm-open');
    document.documentElement.classList.add('cc-mm-open');
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    root.querySelector('.cc-mm__close').focus({preventScroll:true});
  }
  function close() {
    if (!root.classList.contains('is-active')) return;
    root.classList.remove('is-open');
    document.body.classList.remove('cc-mm-open');
    document.documentElement.classList.remove('cc-mm-open');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (root.classList.contains('is-open')) return;
      root.classList.remove('is-active');
      root.setAttribute('aria-hidden', 'true');
      root.inert = true;
      previousFocus?.focus?.({preventScroll:true});
    }, reducedMotion.matches ? 0 : 310);
  }
  tabs.forEach(tab => tab.addEventListener('click', () => selectTab(tab)));
  root.querySelectorAll('[data-cc-mm-close]').forEach(button => button.addEventListener('click', close));
  const getStep = () => Math.max(110, track.querySelector('.cc-mm__tcg-item')?.getBoundingClientRect().width || 116) * 2;
  root.querySelector('[data-cc-mm-prev]')?.addEventListener('click', () => track.scrollBy({left:-getStep(),behavior:'smooth'}));
  root.querySelector('[data-cc-mm-next]')?.addEventListener('click', () => track.scrollBy({left:getStep(),behavior:'smooth'}));
  document.addEventListener('keydown', event => {
    if (!root.classList.contains('is-active')) return;
    if (event.key === 'Escape') {event.preventDefault();close();}
    if (event.key !== 'Tab') return;
    const elements = [...root.querySelectorAll('button:not([disabled]),a[href]')].filter(el => el.getClientRects().length);
    if (!elements.length) return;
    const first=elements[0],last=elements[elements.length-1];
    if (event.shiftKey && document.activeElement===first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
  });
  // Intercept Impulse's existing mobile hamburger before the original drawer opens.
  // Does not affect search, cart, desktop nav or links inside this menu.
  document.addEventListener('click', event => {
    if (window.innerWidth > 768 || event.target.closest('#CCMobileMenu')) return;
    const trigger = event.target.closest('.js-drawer-open-nav, [data-cc-mobile-menu-open], [aria-controls="NavDrawer"], [data-drawer-id="NavDrawer"]');
    if (!trigger || !trigger.closest('.cc-mobile-header-shell, .site-header')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(root)) { document.body.classList.remove('cc-mm-open'); document.documentElement.classList.remove('cc-mm-open'); }
  });
})();
